export enum MatchAssignmentType {
  TOP_RECOMMENDED = 'top_recommended',
  RUNNER_UP = 'runner_up',
  STANDARD = 'standard'
}
